import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Router} from '@angular/router';
import {ServiceConfig} from './service-config';
import {HttpClient} from '@angular/common/http';
@Injectable()
export class CommentTmpService {

  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/commenttmp/';
  // public baseUrl = 'http://localhost/api/department/';
  private data: any;
  private headers: Headers;
  private options: {};

  constructor(private http: HttpClient,
              private router: Router) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
    this.options = {headers: this.headers};
  }

  public index() {
    let url = this.baseUrl + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }
  public getCommentTmpActived(projectId: String) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'getCommentTmpActived/'+projectId+ '?token=' + this.data.token;
    return this.http.get<any>(url);
  }
  public create(body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + 'create?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }

  public update(commenttmpId: String, body) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + commenttmpId + '/update?token=' + this.data.token;
    // console.log(url);
    return this.http.post<any>(url, body);
  }
  public approve(commenttmpId: String) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + commenttmpId + '/approve?token=' + this.data.token;
    // console.log(url);
    return this.http.post<any>(url, this.options);
  }

  public delete(commenttmpId: String) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + commenttmpId + '/delete?token=' + this.data.token;
    // console.log(url);
    return this.http.post<any>(url, this.options);
  }

  

  
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/comment-tmp.service.ts